<template>
  <div>
    <script :id="editorId" type="text/plain"></script>
  </div>
</template>
<script>
  import $ from "&static/UE/third-party/jquery-1.10.2.min.js";
  window.$ = $;
  export default {
    name: 'UE',
    data () {
      return {
        editor: null,
        backupMsg: ''
      }
    },
    props: {
      defaultMsg: {
        type: String
      },
      config: {
        type: Object
      },
      editorId:{
          type: String
      }
    },
    watch: {
      defaultMsg(val){
        this.editor.setContent(val,false)
      }
    },
    mounted() {
      const _this = this;
      this.editor = UE.getEditor(this.editorId, this.config); // 初始化UE
      this.editor.addListener("ready", function () {
        if(_this.backupMsg){
          _this.editor.setContent(_this.backupMsg,false); // 
        }else{
          _this.editor.setContent(_this.defaultMsg,false); // 确保UE加载完成后，放入内容。
        }
      });
    },
    deactivated() {
      this.backupMsg = this.getUEContent()
    },
    methods: {
      getUEContent() { // 获取内容方法
        return this.editor.getContent()
      },
      setUEContent(content){
          if(this.editor){
            this.editor.setContent(content);
          }else{
              console.log('editor尚未初始化')
          }
      }
    },
    beforeDestroy() {
      this.editor.destroy();
    }
  }
</script>
<style type="text/less" lang="less" scoped>
	.el-form-item__content{
        line-height: 16px;
        font-size: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/components/uedtior.vue